<template>
  <div class="branches">
    <select class="form-control" v-model="select" v-on:change="$emit('input',select)">
      <option :value="null" selected>กรุณาเลือกสาขา</option>
      <option v-for="result in results" :value="result.branch_id">{{ result.branch_name }}</option>
    </select>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "branches",
  props: ["value"],
  data() {
    return {
      select: null,
      results: []
    };
  },
  computed: {
    ...mapGetters(["env"])
  },
  components: {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const CALL_API = this.env.VUE_APP_PATH_API;
      this.$http
        .get(`${CALL_API}branches`, {
          headers: {
            Authorization: "Bearer " + this.$session.get("chili").access_token,
            "x-auth-from": this.$session.get("chili").auth_from
          }
        })
        .then(
          response => {
            this.results = response.body.result.branches;
          },
          response => {}
        );
    }
  }
};
</script>
